import React from 'react';
import MinimalDumbo from '../../../DeviationViews/Dumbo/EditorDumbo';
import { Props } from '../ThumbView';

import s from './Literature.scss';

const LiteratureThumbReactView: React.FC<Props> = ({ width, height, deviation }) => (
  <div className={s['root']} style={{ width, height }}>
    <MinimalDumbo width={width} height={height} deviation={deviation} />
  </div>
);

LiteratureThumbReactView.displayName = 'LiteratureThumbReactView';

export default LiteratureThumbReactView;
